<template>
  <div v-if="hasPiiAccess">
    <tooltip fit-content align="right" :disabled="!disabled" message="Oferta não possui segmentos">
      <span v-if="useLink" :class="$wait.is('export-segment-clients') ? 'disabled-link' : 'link'" @click="exportSegment">
        {{ label || 'Baixar todos clientes' }}
      </span>
      <mf-button
        v-else
        :loading="$wait.is('export-segment-clients')"
        :disabled="disabled"
        :size="small ? 'sm' : 'md'"
        :icon="icon || undefined"
        :color="color || undefined"
        text
        outlined
        :label="label || 'Baixar todos clientes'"
        @click="exportSegment"
      />
    </tooltip>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { mapWaitingActions } from 'vue-wait'
import Tooltip from '@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip'

export default {
  components: {
    Tooltip,
  },
  props: {
    segment: {
      type: Object,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    useLink: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
  },
  methods: {
    ...mapWaitingActions({
      exportSegmentClients: 'export-segment-clients',
    }),

    exportSegment() {
      const now = DateTime.now().toFormat('dd-MM-yy')

      if (!this.segment) return

      const fields = [
        'CPF_CNPJ',
        'CODIGO',
        'NOME',
        'DATA_CADASTRO',
        'FONE_1',
        'FONE_2',
        'EMAIL',
        'END_RUA,END_NUMERO,END_BAIRRO,END_CIDADE,END_ESTADO,END_CEP,END_PAIS',
        'DATA_NASCIMENTO',
        'GENERO',
        'TIPO_PESSOA',
        'CLIENTE_DO_CLUBE',
      ]

      this.exportSegmentClients({
        filter: { id_segment: this.segment._id, info_keys: fields },
        fileName: `lista-de-clientes-segmentacao-${now}`,
      })
    },
  },
}
</script>

<style lang="scss">
.disabled-link {
  color: $cinza-0;
  cursor: wait;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.01em;
}
</style>
